export default "__VITE_ASSET__DbKHE$Wx__"